<template>
  <div class="container mb-3">
    <label
      :for="component.name ? component.name : ''"
      class="label v-label mb-3"
    >
      {{ component.label }}
    </label>
    <div class="input-container">
      <div class="switch-container">
        <v-switch
          v-model="model"
          v-bind="{...switchConfig}"
          :id="component.name ? component.name : ''"
        />
      </div>
      <div class="description-container pl-3">
        <generic-html
          v-if="component.description"
          :component="{ html: component.description }"
          class="description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import GenericHtml from '@/components/generic/GenericHtml'

export default {
  components: {
    GenericHtml,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    component: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    // https://vuetifyjs.com/en/api/v-switch/
    switchConfig() {
      return _.get(this.component, 'props.switch', {})
    }
  },
}
</script>

<style lang="scss" scoped>
.label {
  display: block;
  color: rgba(0, 0, 0, 0.6);
}

.input-container {
  display: flex;
  align-items: center;
}

.switch-container {
  flex-shrink: 0;
}

.description-container {
  flex: 1;
}
</style>
